import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { tap, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Authentication } from '../models/authentication';
import { Network } from '@ngx-pwa/offline';
import { UserIdleService } from 'angular-user-idle';
import { AuthFacade } from '../ngrx/auth/auth.facade';

const headers = {
  headers: new HttpHeaders(
    {
      Authorization: 'Basic Z2MuaGFuZGxlLnJlc3Q6d3NvcmUzMjMxMWFmYXNhZHM=',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin': '*'
    }
  )
};

const transformRequest = (credentials) => Object.keys(credentials)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(credentials[key])}`)
  .join('&');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  processLogin(payload: { username: string, password: string, grant_type: string }) {
    const jwtUrl = `/gcmicro/oauth/token`;
    return this.http.post<any>(jwtUrl, transformRequest(payload), headers).pipe(
      tap((auth: Authentication) => {
        return auth;
      }),
      catchError((error: Authentication): Observable<any> => {
        console.error(error);
        return of(error);
      })
    );
  }

  getAccessToken() {
    const authServiceObj = this.authFacade.getDataFromDB();
    return authServiceObj.then( data => data.access_token );
  }

  getRefreshToken() {
    const authServiceObj = this.storage.getLocalValue('authSession', 'json');
    return authServiceObj.refresh_token;
  }

  logout() {
    this.authFacade.deleteDataToDB();
    this.storage.removeLocalValue('selectedID');
    this.storage.removeLocalValue('selectedAssignedAgentId');
    this.storage.removeSessionValue('selectedMainSection');
    this.route.navigate(['/login']);
    setTimeout(() => window.location.reload(), 500);
  }

  refreshToken(refreshToken: string) {
    const jwtUrl = '/gcmicro/oauth/token';
    const payload = {
      grant_type: 'refresh_token',
      refresh_token: refreshToken
    };
    return this.http.post(jwtUrl, transformRequest(payload), headers).pipe(
      tap(data => data),
      catchError(error => {
        console.error('serviceError', error);
        return of(error);
      })
    );
  }

  constructor(
    private http: HttpClient,
    private route: Router,
    private storage: StorageService,
    protected network: Network,
    private userIdle: UserIdleService,
    private authFacade: AuthFacade) { }

}
